<script lang="ts">
    import { useForm, page } from '@inertiajs/svelte';

    const provider: string = $derived($page?.props?.provider ?? '');
    const providerName: string | null = $derived($page?.props?.providerName ?? null);
    const errors = $derived($page?.props?.errors ?? {});

    const form = useForm({
        name: providerName ?? '',
        email: '',
    });

    $effect(() => {
        if (providerName && !$form.name) {
            $form.name = providerName;
        }
    });

    function submit(e: SubmitEvent) {
        e.preventDefault();
        $form.post('/auth/complete-registration');
    }
</script>

<svelte:head>
    <title>Complete Registration — Case of the Day</title>
</svelte:head>

<div class="min-h-screen flex items-center justify-center bg-gray-950">
    <div class="bg-gray-900 rounded-lg shadow border border-gray-700 p-8 w-full max-w-md">
        <h1 class="text-2xl font-bold text-gray-100 mb-2">Complete Registration</h1>
        <p class="text-sm text-gray-400 mb-6">
            Your {provider} account didn't provide an email address. Please enter one to finish signing up.
        </p>

        <form onsubmit={submit} class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Name</label>
                <input
                    bind:value={$form.name}
                    type="text"
                    required
                    class="w-full border rounded px-3 py-2 text-sm bg-gray-800 text-gray-100 {errors.name ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.name}<p class="text-red-500 text-sm mt-1">{errors.name}</p>{/if}
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Email</label>
                <input
                    bind:value={$form.email}
                    type="email"
                    autocomplete="email"
                    required
                    class="w-full border rounded px-3 py-2 text-sm bg-gray-800 text-gray-100 {errors.email ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.email}<p class="text-red-500 text-sm mt-1">{errors.email}</p>{/if}
            </div>
            <button
                type="submit"
                disabled={$form.processing}
                class="w-full bg-cyan-600 text-white py-2 rounded text-sm hover:bg-cyan-500 disabled:opacity-50"
            >
                Complete Registration
            </button>
        </form>
    </div>
</div>
